import React, { useEffect } from "react";
import { ReactComponent as KnightImage } from "./images/knight.svg";
import gsap from "gsap";

export default function Knight({ className = "", animate = true }) {
  useEffect(() => {
    if (!animate) return undefined;
    const shoulderAnimation = gsap.timeline({ repeat: -1 });
    shoulderAnimation.to(["#shoulders", "#arms"], {
      duration: 1,
      ease: "Power3.easeOut",
      translateY: "-0.5px",
    });
    shoulderAnimation.to(["#shoulders", "#arms"], {
      duration: 1,
      ease: "Power3.easeOut",
      translateY: "0.5px",
    });
    shoulderAnimation.yoyo();
    return () => {
      shoulderAnimation.kill();
    };
  }, [animate]);

  const svgClass = ["block", "h-auto", "w-full", "max-w-full", className]
    .filter(Boolean)
    .join(" ");

  return <KnightImage className={svgClass} />;
}
